<template>
	<div class="traffic-mini">
		<div class="traffic-container">
			<transition name="fade" mode="out-in">
				<div class="traffic-summary" v-if="mode == 'traffic'" key="traffic">
					<h2>Traffic Conditions</h2>
					<table>
						<tr v-for="item in routes" :key="item.roadName">
							<th>{{ item.roadName }}</th>
							<td><span v-bind:class="item.condition">{{ item.roadDelay }}</span></td>
						</tr>
					</table>
				</div>
				<div class="traffic-winter" v-if="mode == 'winter'" key="winter">
					<h2>Winter Road Conditions</h2>
					<table>
						<tr v-for="item in routes" :key="item.roadName">
							<th>{{ item.roadName }}</th>
							<td><span v-bind:class="item.condition">{{ item.roadCondition }}</span></td>
						</tr>
					</table>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let updateInterval = 10; // in seconds
	let refreshTimeout = null;

	export default {
		name: 'MiniTraffic',
		data() {
			return {
				mode: null,
				routes: []
			}
		},
		mounted() {
			console.log("Traffic mini module initiated");
			this.updateRoads();
			this.mode = "traffic"
		},

		destroyed() {
			console.log("Stopping Traffic mini module");
			if (refreshTimeout) clearTimeout(refreshTimeout);
		},
		
		methods: {
			updateRoads() {
				var thisMonth = new Date().getMonth();
				var thisDate = new Date().getDate();
				if (this.mode == "traffic" && ((thisMonth >= 10 && thisDate >= 15) || thisMonth >= 11 || thisMonth <= 2 || (thisMonth <= 3 && thisDate <= 15))) {
					this.updateWinter();
				} else {
					this.updateTrafficSummary();
				}
			},
			updateTrafficSummary() {
				let self = this;
				this.$http.get('/traffic/summary').then(response => {
					let result = response.body;

					// Iterate through results to determine display severity
					for (var x = 0, len = result.length; x < len; x++) {
						let item = result[x];
						let delay = item.actualTravelTime - item.normalTravelTime;
						item.roadDelay = delay > 1 ? delay + " min delay" : "Good";
						if (delay <= 1) {
							item.condition = "normal";
						} else if (delay < 5) {
							item.condition = "low";
						} else if (delay < 10) {
							item.condition = "medium";
						} else {
							item.condition = "high";
						}
					}

					self.mode = "traffic";
					self.routes = result;
					refreshTimeout = setTimeout(self.updateRoads, 1000*updateInterval);
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
					refreshTimeout = setTimeout(self.updateRoads, 1000*updateInterval);
				});
			},
			updateWinter() {
				let self = this;

				this.$http.get('/traffic/winter').then(response => {
					let result = response.body;

					// Iterate through results to determine display severity
					for (var x = 0, len = result.length; x < len; x++) {
						let item = result[x];
						if (item.roadCondition.toLowerCase().indexOf("not advised") !== -1) {
							item.condition = "high";
						} else if (item.roadCondition.toLowerCase().indexOf("completely") !== -1) {
							item.condition = "medium";
						} else if (item.roadCondition.toLowerCase().indexOf("partially") !== -1) {
							item.condition = "low";
						} else {
							item.condition = "normal";
							item.roadCondition = "Good"
						}
					}

					if (result.length > 0) {
						self.mode = "winter";
						self.routes = result;
					}
					refreshTimeout = setTimeout(self.updateRoads, 1000*updateInterval);
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
					refreshTimeout = setTimeout(self.updateRoads, 1000*updateInterval);
				});
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	@bg-traffic: #008C46;

	.traffic-mini {
		height: 65%;

		.traffic-container {
			.padded-widget(@bg-traffic);
			color: #fff;
			font-family: @font-main;
		}

		.traffic-summary {

			h2 {
				text-align: center;
				text-transform: uppercase;
				font-size: 2.2em;
				line-height: 1em;
				margin: 0 0 0.6em;
			}

			table {
				border-collapse: collapse;
				border-spacing: 0;
				width: 100%;
			}

			th, td {
				font-size: 1.8em;
				line-height: 1em;
			}

			th {
				text-align: left;
				font-weight: 400;
				padding: 0.4em 0.8em 0.4em 0;
			}

			td {
				text-align: right;
				padding: 0.4em 0 0.4em 0.8em;

				span {
					display: inline-block;
					margin: -0.3em;
					padding: 0.3em;
					border-radius: 0.3em;

					&.low {
						background-color: #AA0;
					}

					&.medium {
						background-color: #D60;
					}
					&.high {
						background-color: #D00;
					}
				}
			}
		}

		.traffic-winter {

			h2 {
				text-align: center;
				text-transform: uppercase;
				font-size: 2.2em;
				line-height: 1em;
				margin: 0 0 0.5em;
			}

			table {
				border-collapse: collapse;
				border-spacing: 0;
				width: 100%;
			}

			th, td {
				font-size: 1.5em;
				line-height: 1em;
			}

			th {
				text-align: left;
				font-weight: 400;
				padding: 0.4em 0.8em 0.4em 0;
			}

			td {
				text-align: right;
				padding: 0.4em 0 0.4em 0.8em;
	
				span {
					display: inline-block;
					margin: -0.3em;
					padding: 0.3em;
					border-radius: 0.5em;

					&.low {
						background-color: #AA0;
					}

					&.medium {
						background-color: #D60;
					}
					&.high {
						background-color: #D00;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// traffic-mini.vue?dd050d3a